import React, {useState, useEffect, Fragment} from "react";
import { isAuthenticated } from "./helper";
import { Link } from "react-router-dom";
import {useParams} from "react-router-dom"
import AppTheme from "../colors";

const SinglePost = () => {
    const theme = JSON.parse(localStorage.getItem("theme"));
    const currentTheme =  AppTheme["light"]
    const [comment, setComment] = useState("")
    const [post, setPost] =useState([]);
    const {postId} = useParams()
    const {user, token} = isAuthenticated()
    const [loading, setLoading] = useState(true)
    useEffect(() => {
        fetch(`${process.env.REACT_APP_BACKEND}/singlepost/${postId}`, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
        .then(res=> res.json())
        .then(data => {
            console.log(data);
            setLoading(false)
            setPost(data)
        })
        .catch(err => console.log(err))
    }, [])

    const likePost = (id) => {
        fetch(`${process.env.REACT_APP_BACKEND}/like/${user._id}`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({
                postId: id
            })
        })
        .then(res=> res.json())
        .then(data => {
            const newPost = post.map(item => {
                if(item._id == data._id){
                    return data
                }
                else{
                    return item
                }
            })
            setPost(newPost)
        })
        .catch(err => console.log(err))
    }
    const unLikePost = (id) => {
        fetch(`${process.env.REACT_APP_BACKEND}/unlike/${user._id}`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({
                postId: id
            })
        })
        .then(res=> res.json())
        .then(data => {
            const newPost = post.map(item => {
                if(item._id == data._id){
                    return data
                }
                else{
                    return item
                }
            })
            setPost(newPost)
        })
        .catch(err => console.log(err))
    }

    const makeComment = (text, postId) => {
        fetch(`${process.env.REACT_APP_BACKEND}/comment/${user._id}`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({
                postId,
                text
            })
        })
        .then(res => res.json())
        .then(data => {
            console.log(data)
            const newPost = post.map(item => {
                if(item._id == data._id){
                    return data
                }
                else{
                    return item
                }
            })
            setPost(newPost)
            setComment("")
        })
        .catch(err => console.log(err))
    }

    const deletePost = (postId) => {
        fetch(`${process.env.REACT_APP_BACKEND}/delete/${postId}/${user._id}`, {
            method: "DELETE",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            }
        })
        .then(res=>res.json())
        .then(result => {
            console.log(result)
            const newData = post.filter(item => {
                return item._id !== result._id
            })  
            setPost(newData)
        })
        .catch(err => console.log(err))
    }

    const deleteComment = (postId, commentId) => {
        fetch(`${process.env.REACT_APP_BACKEND}/deletecomment/${postId}/${commentId}/${user._id}`, {
            method: "DELETE",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            }
        })
        .then(res => res.json())
        .then(data => {
            console.log(data)
            const newPost = post.map(item => {
                if(item._id == data._id){
                    return data
                }
                else{
                    return item
                }
            })
            setPost(newPost)
        })
        .catch(err => console.log(err))
    }

    return (
        <>
        
            <div className="row">
            <div className="col s12">
                <div className="home">
                {
                    post.map(item => {
                        return( 
                            
                            
                            <div className="card home-card"  key={item._id} style={{backgroundColor: `${currentTheme.navColor}`, color: `${currentTheme.textColor}`}}>
                                <h5 style={{textAlign:"left", marginLeft: "3%"}}>
                                
                                <img className="circle" height="40" width="40" style={{marginTop: "5px", marginRight: "5px"}} src={item.postedBy.pic}/>
                                <Link to={item.postedBy._id !== user._id ? `/profile/${item.postedBy._id }` : "/profile"}>
                                <span style={{paddingBottom: "3%", color: `${currentTheme.textColor}`}}>{item.postedBy.name}</span>
                                </Link>
                                {item.postedBy._id === user._id ? (
                                    <i className="material-icons right" style={{float:"right"}} 
                                    onClick={() => deletePost(item._id)} >delete</i>
                                ) : ""}
                                
                                </h5>
                                <div className="card-image">
                                    <img src={item.photo}/>
                                </div>
                                <div className="card-content">
                                    
                                    {item.likes.includes(user._id) ? (
                                        <i className="material-icons" onClick={() => {unLikePost(item._id)}} style={{color: "red"}}>favorite</i>
                                    ) : (
                                        <i className="material-icons" onClick={() => {likePost(item._id)}} style={{color: "red"}}>favorite_border</i>
                                    )}
                                    
                                    
                                    <h6>{item.likes.length} likes</h6>
                                    <h6>{item.title}</h6>
                                    <p>{item.body}</p>
                                    {
                                        item.comments.map(record => {
                                            return (
                                                <h6 key={record._id}><span style={{fontWeight: "700"}}>{record.postedBy.name}</span> {record.text} 
                                                {record.postedBy._id === user._id && (
                                                    <i className="material-icons right" 
                                                    onClick={() => deleteComment(item._id, record._id)} >delete</i>
                                                )}
                                                
                                                
                                                </h6>
                                            )
                                        })
                                    }   
                                    <form onSubmit={(e)=>{
                                        e.preventDefault()
                                        
                                        makeComment(comment, item._id)
                                    }}>
                                        <input type="text" placeholder="add a comment" value={comment} 
                                        onChange={(e) => {setComment(e.target.value)}} style={{color: `${currentTheme.textColor}`}}/>
                                    </form>
                                    
                                </div>
                            </div>
                            
                        )
                    })
                }
                    
                </div>
            </div>
            {loading && 
                <div className="preloader-background">
            <div class="preloader-wrapper big active">
                <div class="spinner-layer spinner-blue-only">
                <div class="circle-clipper left">
                    <div class="circle"></div>
                </div><div class="gap-patch">
                    <div class="circle"></div>
                </div><div class="circle-clipper right">
                    <div class="circle"></div>  
                </div>
                </div>
            </div>
            </div>
            }
        </div>
        
        </>
        
    )
}

export default SinglePost;